import { Modal as AntModal, ModalProps } from 'antd'

const Modal = (props: ModalProps) => {
    return <AntModal {...props}>{props.children}</AntModal>
}

// Individual re-exports of AntModal static methods to retain correct typing
Modal.confirm = AntModal.confirm
Modal.info = AntModal.info
Modal.success = AntModal.success
Modal.error = AntModal.error
Modal.warning = AntModal.warning

export default Modal
